
import React from 'react';

export default class LanguageBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageSelected: props.languageSelected || [],
      testOrderNo: 0,
      langConfig: {
        test: 0,
        sequence: [],
      },
      pageIndex: 0,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { languageSelected, langConfig, pageIndex } = this.state;
    if((languageSelected.length == 0 && pageIndex == 0) || (langConfig.sequence.length == 0 && pageIndex == 1)) {
      // No selections made
      return;
    }

    if(pageIndex === 0 && languageSelected.length == 2) {
      // Go to next page
      this.setState({
        pageIndex: 1,
        // set Default selection
        testOrderNo: 1,
        langConfig: {
          test: 2,
          sequence: ['esp', 'eng'],
        }
      });
    } else {
      const languageSelection = languageSelected.length === 1
        ? { test: 1, sequence: languageSelected }
        : langConfig;
      this.props.saveLanguageSelection(languageSelection);
    }
  }

  selectLang(lang) {
    this.setState((prevState) => ({
      languageSelected: prevState.languageSelected.includes(lang)
        ? prevState.languageSelected.filter((l) => l !== lang)
        : prevState.languageSelected.concat([lang]),
    }));
  }

  render() {
    const { selectedSchool } = this.props;
    const { pageIndex, languageSelected, testOrderNo, langConfig } = this.state;

    return (
      <div className="LanguageModal">
        <div className="language-modal-title">{selectedSchool.label}'s Assessment Configuration</div>
        <div className='language-modal-content'>
        {pageIndex === 0
        ? <React.Fragment>
            <div className='lang-sub-title'>SELECT LANGUAGE</div>
            <div className='lang-opt-side-by-side'>
              <div
                className={'lang-opt-box' + (languageSelected.includes('eng') ? ' checked' : '')}
                onClick={(e) => {
                  this.selectLang('eng');
                }}>
                <span>English</span>
                <input
                  className="lang-opt-input"
                  name="english"
                  type="checkbox"
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => this.selectLang('eng')}
                  checked={languageSelected.includes('eng')}
                />
              </div>
              <div
                className={'lang-opt-box' + (languageSelected.includes('esp') ? ' checked' : '')}
                onClick={(e) => {
                  this.selectLang('esp');
                }}>
                <span>Spanish</span>
                <input
                  className="lang-opt-input"
                  name="spanish"
                  type="checkbox"
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => this.selectLang('esp')}
                  checked={languageSelected.includes('esp')}
                />
              </div>
            </div>
          </React.Fragment>
        : <React.Fragment>
            <div className='lang-sub-title'># of TESTS</div>
            <div>
              <div onClick={() => this.setState({ testOrderNo: 1, langConfig: { test: 2, sequence: ['esp', 'eng']}})}>
                <input
                  name="testOrder"
                  type="radio"
                  checked={testOrderNo === 1}
                  onChange={() => this.setState({ testOrderNo: 1, langConfig: { test: 2, sequence: ['esp', 'eng']}})}
                />
                <label>2 Tests, Spanish then English</label>
              </div>
              <div onClick={() => this.setState({ testOrderNo: 2, langConfig: { test: 2, sequence: ['eng', 'esp']}})}>
                <input
                  name="testOrder"
                  type="radio"
                  checked={testOrderNo === 2}
                  onChange={() => this.setState({ testOrderNo: 2, langConfig: { test: 2, sequence: ['eng', 'esp']}})}
                />
                <label>2 Tests, English then Spanish</label>
              </div>
              <div onClick={() => this.setState({ testOrderNo: 3, langConfig: { test: 1, sequence: ['esp', 'eng']}})}>
                <input
                  name="testOrder"
                  type="radio"
                  checked={testOrderNo === 3}
                  onChange={() => this.setState({ testOrderNo: 3, langConfig: { test: 1, sequence: ['esp', 'eng']}})}
                />
                <label>1 Test, Spanish then English</label>
              </div>
              <div onClick={() => this.setState({ testOrderNo: 4, langConfig: { test: 1, sequence: ['eng', 'esp']}})}>
                <input
                  name="testOrder"
                  type="radio"
                  checked={testOrderNo === 4}
                  onChange={() => this.setState({ testOrderNo: 4, langConfig: { test: 1, sequence: ['eng', 'esp']}})}
                />
                <label>1 Test, English then Spanish</label>
              </div>
              <div></div>
            </div>
          </React.Fragment>
        }
          <div className='lang-modal-control'>
            <div
              className={'lang-control-btn' + (((languageSelected.length > 0 && pageIndex == 0) || (langConfig.sequence.length > 0 && pageIndex == 1)) ? '' : ' disabled')}
              onClick={this.handleClick}
            >
              {(languageSelected.length == 2 && pageIndex == 0) ? "Next" : "Confirm"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}